import React, { useState } from "react";
import { motion } from "motion/react";
import { supabase } from "../../lib/supabase";

export default function ExpertSettingsTab({ user, updateUser }) {
  const [settingsName, setSettingsName] = useState(user?.name || "");
  const [settingsEmail, setSettingsEmail] = useState(user?.email || "");
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [settingsSaved, setSettingsSaved] = useState(false);

  const handleSaveSettings = async () => {
    if (!user?.id) return;
    setSettingsSaving(true);
    try {
      const { error } = await supabase
        .from("profiles")
        .update({
          name: settingsName,
          updated_at: new Date().toISOString()
        })
        .eq("id", user.id);
      if (!error) {
        if (updateUser) updateUser({ name: settingsName });
        setSettingsSaved(true);
        setTimeout(() => setSettingsSaved(false), 3000);
      }
    } catch (err) {
      console.error("Settings save error:", err);
    } finally {
      setSettingsSaving(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <h2 className="text-2xl font-medium text-white">Настройки</h2>

      <div className="p-6 rounded-2xl bg-neutral-900 border border-neutral-800">
        <h3 className="text-xl font-medium text-white mb-4">Личные данные</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-lg font-extralight text-neutral-400 mb-2">Имя</label>
            <input
              type="text"
              value={settingsName}
              onChange={(e) => setSettingsName(e.target.value)}
              className="w-full px-4 py-3 rounded-xl bg-neutral-800 border border-neutral-700 text-white text-lg font-extralight focus:outline-none focus:border-primary-500"
            />
          </div>
          <div>
            <label className="block text-lg font-extralight text-neutral-400 mb-2">Email</label>
            <input
              type="email"
              value={settingsEmail}
              disabled
              className="w-full px-4 py-3 rounded-xl bg-neutral-800 border border-neutral-700 text-neutral-500 text-lg font-extralight focus:outline-none cursor-not-allowed"
            />
          </div>
          <button
            onClick={handleSaveSettings}
            disabled={settingsSaving}
            className="px-6 py-3 rounded-xl bg-primary-600 hover:bg-primary-500 disabled:bg-neutral-700 text-white text-lg font-extralight transition-colors"
          >
            {settingsSaving ? "Сохранение..." : settingsSaved ? "Сохранено!" : "Сохранить изменения"}
          </button>
        </div>
      </div>

      <div className="p-6 rounded-2xl bg-neutral-900 border border-neutral-800">
        <h3 className="text-xl font-medium text-white mb-4">Уведомления</h3>
        <div className="space-y-4">
          {["Email-уведомления", "Push-уведомления"].map((label) => (
            <label key={label} className="flex items-center justify-between cursor-pointer">
              <span className="text-lg font-extralight text-neutral-300">{label}</span>
              <div className="relative">
                <input type="checkbox" className="sr-only peer" defaultChecked={label.includes("Email")} />
                <div className="w-11 h-6 bg-neutral-700 rounded-full peer peer-checked:bg-primary-600 transition-colors"></div>
                <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-5 transition-transform"></div>
              </div>
            </label>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
